export const own = {}.hasOwnProperty
